/* DON'T EDIT THIS FILE: edit original and run build again */ export function notNull<T>(value: T | null | undefined): NonNullable<T> {
  if (value === undefined) {
    throw new Error("invalidUndefined");
  }
  if (value === null) {
    throw new Error("invalidNull");
  }
  return value;
}
